import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Auth
import Login from './pages/Login';
import PatientRegister from './pages/PatientRegister';
import Unauthorized from './pages/Unauthorized';

// Superadmin
import SuperAdminLayout from './layouts/SuperAdminLayout';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import WebStatsPage from './pages/WebStatsPage';
import DoctorsManagement from './pages/DoctorsManagement';
import InstitutionsManagement from './pages/InstitutionsManagement';
import SubscriptionsPage from './pages/SubscriptionsPage';

// Doctor
import DoctorLayout from './layouts/DoctorLayout';
import DoctorDashboard from './pages/DoctorDashboard';
import PatientsManagement from './pages/PatientsManagement';
import ConsultationsPage from './pages/ConsultationsPage';
import AppointmentsPage from './pages/AppointmentsPage';
import MessagesPage from './pages/MessagesPage';
import MyNursesPage from './pages/MyNursesPage';
import DoctorSettingsPage from './pages/DoctorSettingsPage';

// Nurse
import NurseLayout from './layouts/NurseLayout';
import NurseDashboard from './pages/NurseDashboard';
import TriajePage from './pages/TriajePage';

// Patient
import PatientLayout from './layouts/PatientLayout';
import PatientDashboard from './pages/PatientDashboard';
import PatientMedicalHistory from './pages/PatientMedicalHistory';
import PatientAppointments from './pages/PatientAppointments';
import PatientMessages from './pages/PatientMessages';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<PatientRegister />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Superadmin Routes */}
          <Route
            path="/superadmin"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperAdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<SuperAdminDashboard />} />
            <Route path="doctors" element={<DoctorsManagement />} />
            <Route path="institutions" element={<InstitutionsManagement />} />
            <Route path="subscriptions" element={<SubscriptionsPage />} />
            <Route path="web-stats" element={<WebStatsPage />} />
          </Route>

          {/* Doctor Routes */}
          <Route
            path="/doctor"
            element={
              <ProtectedRoute allowedRoles={['doctor']}>
                <DoctorLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DoctorDashboard />} />
            <Route path="patients" element={<PatientsManagement />} />
            <Route path="consultations" element={<ConsultationsPage />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="my-nurses" element={<MyNursesPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="settings" element={<DoctorSettingsPage />} />
          </Route>

          {/* Nurse Routes */}
          <Route
            path="/nurse"
            element={
              <ProtectedRoute allowedRoles={['nurse']}>
                <NurseLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<NurseDashboard />} />
            <Route path="triaje" element={<TriajePage />} />
            <Route path="patients" element={<PatientsManagement />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="messages" element={<MessagesPage />} />
          </Route>

          {/* Patient Routes */}
          <Route
            path="/patient"
            element={
              <ProtectedRoute allowedRoles={['patient']}>
                <PatientLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<PatientDashboard />} />
            <Route path="medical-history" element={<PatientMedicalHistory />} />
            <Route path="appointments" element={<PatientAppointments />} />
            <Route path="messages" element={<PatientMessages />} />
          </Route>

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
